export interface PillSwitchRebrandProps {
  options: readonly { label: string; value: string }[]
  value: string
  onChange: (next: string) => void
  ariaLabel?: string
  className?: string
}

export const PillSwitchRebrand = ({
  options,
  value,
  onChange,
  ariaLabel,
  className = ''
}: PillSwitchRebrandProps) => (
  <div
    role='radiogroup'
    aria-label={ariaLabel}
    className={`bg-limeFresh/50 inline-flex w-fit items-center gap-[3px] rounded-full p-[2px] ${className}`}
  >
    {options.map(option => {
      const isActive = option.value === value
      return (
        <button
          key={option.value}
          type='button'
          role='radio'
          aria-checked={isActive}
          onClick={() => onChange(option.value)}
          className={`font-body-rebrand flex items-center justify-center rounded-full px-6 py-2 text-base sm:text-lg leading-[1.6] font-extrabold transition-colors ${
            isActive
              ? 'bg-forestDeep text-limeFresh'
              : 'text-forestDeep hover:bg-forestDeep/10'
          }`}
        >
          {option.label}
        </button>
      )
    })}
  </div>
)

export default PillSwitchRebrand
